module.exports = (state, action) => {
  const { boxId, boxAlias } = action.payload
  
  if (boxId !== undefined) {
    state.boxes[boxId].boxalias = boxAlias
    return state
  } else {
    throw new Error('Cannot edit box with id: undefined')
  }
}
